<template>
    <ct-row wrap="nowrap" class="question-section">
      <ct-col :span="10">
        <span class="badge badge-index">{{index}}</span>
<!--        <span v-if="isRight" class="passed badge">pass</span>-->
<!--        <span v-else class="not-pass badge">not pass</span>-->
        <span  class="badge badge-default" v-for="(item, i ) in modules" :key="i">
          {{item}}
        </span>
      </ct-col>
      <ct-col style="text-align: right" :span="14">
      <comments-button
        class="no-margin"
        :dis-inline="computedUseful"
        :dis-none="$t('question.Like')"
        :active="!!selfUseful?'active':''"
        @click="questionUseful"
        >
        <ct-icon name="useful" class="comments-button-icon"></ct-icon>
      </comments-button>
      <comments-button
        :dis-inline="computedInteresting"
        :dis-none="$t('question.Interesting')"
        :active="!!selfInteresting?'active':''"
        @click="questionInteresting"
        >
          <ct-icon name="interesting" class="comments-button-icon"></ct-icon>
      </comments-button>
      </ct-col>
    </ct-row>
</template>
<script>
import api from '@ca/api'
import CommentButton from './sub/CommentButton'
import { questionType } from '@ca/constants'

export default {
  name: 'QuestionStatus',
  components: {
    'comments-button': CommentButton
  },
  props: {
    id: Number,
    index: {
      type: Number,
      required: true
    },
    isRight: {
      type: Boolean,
      default: null
    },
    modules: {
      type: Array,
      default: () => {
        return []
      }
    },
    interesting: {
      type: Number,
      default: 0
    },
    useful: {
      type: Number,
      default: 0
    },
    self_interesting: {
      type: Number,
      default: 0
    },
    self_useful: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      pending: false,
      clickedInteresting: true,
      clickedUseful: false,
      interestingText: 0,
      usefulText: 0,
      questionType: questionType[this.$route.path.split('/')[1]]
    }
  },
  watch: {
    interesting (value) {
      this.interestingText = value
    },
    useful (value) {
      this.usefulText = value
    },
    self_interesting (value) {
      this.clickedInteresting = !!value
    },
    self_useful (value) {
      this.clickedUseful = !!value
    }
  },
  computed: {
    computedInteresting () {
      return this.interestingText
    },
    computedUseful () {
      return this.usefulText
    },
    selfUseful () {
      return this.clickedUseful
    },
    selfInteresting () {
      return this.clickedInteresting
    }
  },
  methods: {
    questionUseful (type) {
      if (this.pending) {
        return false
      }
      this.pending = true
      const state = !this.clickedUseful
      this.clickedUseful = state
      const value = this.clickedUseful ? 1 : -1
      //   const questionType = this.questionType
      api.questionUseful({
        data: {
          question_id: this.id,
          type: 'top',
          value,
          question_type: 1,
          class_id: +this.$route.params.class_id,
          subclass_id: +this.$route.params.subclass_id
        }
      }).then(res => {
        if (res.data && res.data.code === 1) {
          this.usefulText = res.data.data.top || (this.usefulText + value)
          this.$emit('update-question', { top: this.usefulText, self_top: this.clickedUseful ? 1 : 0 })
        } else {
          this.clickedUseful = !state
        }
        this.pending = false
      }, () => {
        this.clickedUseful = !state
        this.pending = false
      })
    },
    questionInteresting () {
      if (this.pending) {
        return false
      }
      this.pending = true
      const state = !this.clickedInteresting
      this.clickedInteresting = state
      const value = this.clickedInteresting ? 1 : -1
      //   const questionType = this.questionType
      api.questionInteresting({
        data: {
          question_id: this.id,
          type: 'interesting',
          value,
          question_type: 1,
          class_id: +this.$route.params.class_id,
          subclass_id: +this.$route.params.subclass_id
        }
      }).then(res => {
        if (res.data && res.data.code === 1) {
          this.interestingText = res.data.data.interesting || (this.interestingText + value)
          this.$emit('update-question', { interesting: this.interestingText, self_interesting: this.clickedInteresting ? 1 : 0 })
        } else {
          this.clickedInteresting = !state
        }
        this.pending = false
      }, () => {
        this.clickedInteresting = !state
        this.pending = false
      })
    }
  },
  mounted () {
    this.clickedUseful = !!this.self_useful
    this.clickedInteresting = !!this.self_interesting
    this.interestingText = this.interesting
    this.usefulText = this.useful
  }
}
</script>
<style lang="scss" scoped>
@import '@/styles/_varaible.scss';
.badge {
  display: inline-block;
  border-radius:2px;
  vertical-align: middle;
  font-size:12px;
  font-family:SFProDisplay-Regular;
  font-weight:400;
  line-height:12px;
  padding: 6px 8px;
  &-index {
    font-size:16px;
    font-family:SFProDisplay-Medium;
    font-weight:500;
    padding: 5px 10px;
    background:$primary;
    height: 24px;
    color: #fff;
    line-height: 14px;
  }
  &.passed{
    background:rgba(55,202,215,0.1);
    color: $primary;
  }
  &.not-pass{
    background:#F7FBFF;
  }
 &-default{
    background:#F7FBFF;
  }
  &-default,
  &.not-pass {
    color:$secondary;
  }
}
.badge + .badge{
  margin-left: 8px;
}
.comments-button-icon{
  font-size:19px;
  vertical-align: text-bottom;
}
</style>
